import React from "react";
import { AppFormControl } from "../controls/formControl";
import { IconTypes, RenderIcons } from "../controls/icons";

const _props = {
  form: {},
  fields: [],
  existingDocInfo: {}
};
export const RenderForm = (props = _props) => {
  if (
    !props.form ||
    !props.fields ||
    !Array.isArray(props.fields) ||
    props.fields.length < 1
  )
    return null;

  function rn(ctrls, fieldName = "") {
    return (
      <>
        {ctrls.map((field, index) => {
          if (!field.fields) {
            const controlName =
              fieldName > "" ? `${fieldName}.${field.field}` : field.field;
            const edit = field.edit || {};
            if (!edit.enabled) return null;
            return (
              <React.Fragment key={index}>
                <AppFormControl
                  inputForm = {props.inputForm}
                  user = {props.user}
                  form={props.form}
                  existingDocInfo={props.existingDocInfo}
                  setIsUploadComplete={props.setIsUploadComplete}
                  controlConfig={{
                    ...edit,
                    options: field.options,
                    field: controlName,
                    name: controlName,
                    dataMappingAtRuntime: field.dataMappingAtRuntime,
                    mappedChildField: field.mappedChildField,
                    mappedParentField: field.mappedParentField,
                  }}
                />
              </React.Fragment>
            );
          } else if (Array.isArray(field.fields)) {
            const baseControlName =
              fieldName > "" ? `${fieldName}.${field.field}` : field.field;
            return (
              <React.Fragment key={index}>
                {rn(field.fields, baseControlName)}
              </React.Fragment>
            );
          }
        })}
      </>
    );
  }

  return (
    <div className={"form_wrapper form_wrapper_control row"}>
      {rn(props.fields)}
      <div className="col-md-6 gc_captcha">
        {props.imageLoaded && (
         <div className="gc_captcha_img"> <img
            src={`data:image/svg+xml;utf8,${encodeURIComponent(
              props.captchaImage
            )}`}
          /></div>
        )}
        {props.imageLoaded && (
        <div className="rc_captcha_refresh" onClick={props.refreshCaptcha}>
          <span>

            <svg
              width="10"
              height="12"
              viewBox="0 0 10 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.69185 2.40406C6.93593 2.1809 6.93593 1.8191 6.69185 1.59594L5.12935 0.167368C4.88527 -0.0557892 4.48954 -0.0557892 4.24546 0.167368C4.00139 0.390524 4.00139 0.752333 4.24546 0.97549L4.7473 1.43431C2.10329 1.55464 0 3.55275 0 6C0 7.09574 0.422447 8.10281 1.12597 8.89025C1.34434 9.13466 1.73807 9.17095 2.0054 8.9713C2.27273 8.77165 2.31241 8.41166 2.09405 8.16725C1.56616 7.57641 1.25 6.82273 1.25 6C1.25 4.18898 2.78578 2.70591 4.73156 2.58008L4.24546 3.02451C4.00139 3.24767 4.00139 3.60948 4.24546 3.83263C4.48954 4.05579 4.88527 4.05579 5.12935 3.83263L6.69185 2.40406ZM7.74307 2.83203C7.49274 3.04932 7.48246 3.411 7.72012 3.63988C8.35896 4.25513 8.75 5.0852 8.75 6C8.75 7.81103 7.21422 9.29409 5.26844 9.41992L5.75454 8.97549C5.99861 8.75233 5.99861 8.39052 5.75454 8.16737C5.51046 7.94421 5.11473 7.94421 4.87065 8.16737L3.30815 9.59594C3.06407 9.8191 3.06407 10.1809 3.30815 10.4041L4.87065 11.8326C5.11473 12.0558 5.51046 12.0558 5.75454 11.8326C5.99861 11.6095 5.99861 11.2477 5.75454 11.0245L5.2527 10.5657C7.89671 10.4454 10 8.44725 10 6C10 4.78086 9.4772 3.67214 8.62666 2.85302C8.389 2.62414 7.99341 2.61474 7.74307 2.83203Z"
                fill="#3265AA"
              />
            </svg>
          </span>
        </div>)}
      </div>
    </div>
  );
};
